import React from 'react';
import { SortableDropZone } from '../../../../../../components/Sortable';
import { IMPORTANT_PATIENT_INFORMATION } from '../../../../constants';

type MedicationDropZoneProps = {
  id: string;
  disabled: boolean;
  children: React.ReactNode;
  sectionName: string;
  activeDragType: 'section' | 'medication' | null;
  activeDragSourceSectionName: string | null;
};

const MedicationDropZone = ({
  id,
  disabled,
  children,
  sectionName,
  activeDragType,
  activeDragSourceSectionName,
}: MedicationDropZoneProps) => {
  const isMedicationDropTarget =
    !disabled &&
    activeDragType === 'medication' &&
    activeDragSourceSectionName !== IMPORTANT_PATIENT_INFORMATION;

  return (
    <SortableDropZone
      id={id}
      disabled={disabled}
      ready={
        isMedicationDropTarget && activeDragSourceSectionName !== sectionName
      }
      readyStyle={{
        backgroundColor: 'rgba(0, 139, 209, 0.1)',
      }}
      overStyle={
        isMedicationDropTarget
          ? {
              backgroundColor: 'rgba(0, 139, 209, 0.16)',
            }
          : undefined
      }
    >
      {children}
    </SortableDropZone>
  );
};

export default MedicationDropZone;
